module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "oco2-mip-co2budget-yeargrid-v1--cover.a675fc71.jpg";